export default "__VITE_ASSET__DUfb6Nkq__"